import { render, staticRenderFns } from "./PendingPriceModal.vue?vue&type=template&id=7560ed55&"
import script from "./PendingPriceModal.vue?vue&type=script&lang=js&"
export * from "./PendingPriceModal.vue?vue&type=script&lang=js&"
import style0 from "./PendingPriceModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports